import $http from '../../shared/http';

export const visitors = {
  namespaced: true,
  state: () => {
    return {
      visitorRecords: [],
      currentVisitor: null,
      currentVisitorEditData: {},
      visitorsForSearchSelect: null,
    };
  },
  getters: {
    getCurrentVisitor: (state) => state.currentVisitor,
    getCurrentVisitorEditData: (state) => state.currentVisitorEditData,
    getVisitorsForSearchSelect: (state) => state.visitorsForSearchSelect,
  },
  mutations: {
    setCurrentVisitor: (state, data) => {
      state.currentVisitor = data;
    },
    setVisitorRegisterData: (state, payload) => (state.visitorRegisterData = payload),
    setVisitorEditData: (state, payload) => (state.visitorEditData = payload),
    clearRegisterResponseData: (state) => {
      state.newVisitorID = null;
      state.visitorCreated = null;
    },
    clearEditResponseData: (state) => {
      state.editedVisitorID = null;
      state.visitorEdited = null;
    },
    setVisitorsForSearchSelect: (state, payload) => (state.visitorsForSearchSelect = payload),
    resetVisitorsForSearchSelect: (state) => (state.visitorsForSearchSelect = null),
  },
  actions: {
    async fetchVisitor({ commit }, { id, churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/visitors/${id}`)
        .then((response) => {
          commit('setCurrentVisitor', response.data.data);
          return response;
        });
    },

    async createVisitorAction(ctx, { form, churchId }) {
      return $http('v2')
        .post(`organisations/${churchId}/visitors`, form, {
          notifiable: true,
        })
        .then((response) => {
          return response.data.data;
        });
    },

    async editVisitorAction(ctx, { id, form, churchId }) {
      return $http('v2')
        .patch(`organisations/${churchId}/visitors/${id}`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then((response) => {
          return response.data.data.id;
        });
    },

    async LINK_SUGGESTED_VISITOR_TO_CURRENT_SERVICE(ctx, { serviceId, visitorIds, churchId }) {
      return $http('v2').post(
        `organisations/${churchId}/services/${serviceId}/visitors`,
        { ids: visitorIds },
        {
          notifiable: true,
        }
      );
    },

    async DELETE_VISITOR_ACTION(ctx, { id, churchId }) {
      return $http('v2').delete(`organisations/${churchId}/visitors/${id}`, { notifiable: true });
    },

    async DELETE_SERVICE_VISITOR_ACTION(ctx, { id, churchId, serviceId }) {
      return $http('v2').delete(`organisations/${churchId}/services/${serviceId}/visitors/${id}`, {
        notifiable: true,
      });
    },

    async loadVisitorsForSearchSelect({ commit }, { churchId, full_name }) {
      commit('setVisitorsForSearchSelect', null);
      return $http('v2')
        .get(`organisations/${churchId}/visitors/search/select`, {
          params: {
            full_name,
          },
        })
        .then((response) => {
          commit('setVisitorsForSearchSelect', response.data.data);
          return response;
        });
    },

    async GET_EXISTING_VISITORS_SUGGESTIONS(ctx, { churchId, ...query }) {
      return $http('v2')
        .get(`organisations/${churchId}/visitors_suggestions`, {
          params: {
            ...query,
          },
        })
        .then((response) => {
          return response.data;
        });
    },
  },
};
